import { render, staticRenderFns } from "./omt-textarea.vue?vue&type=template&id=0449236a&scoped=true&"
import script from "./omt-textarea.vue?vue&type=script&lang=js&"
export * from "./omt-textarea.vue?vue&type=script&lang=js&"
import style0 from "./omt-textarea.vue?vue&type=style&index=0&id=0449236a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0449236a",
  null
  
)

export default component.exports